import type { ProductItem } from "@nwt/norce-pwa/dist/runtime/types/api/product/product";

export function useCatalogAddToCart() {
	const cartStore = useCartStore();
	const { addToCart } = useGtmEvents();
	const productStore = useProductStore();

	const add = async (item: ProductItem) => {
		await cartStore.addToCart({
			PartNo: item.PartNo!,
			Quantity: 1,
			PriceListId: item.PriceListId || productStore?.priceLists?.[0]?.Id,
			Name: item.VariantName || item.Name,
			Comment: null
		});
		addToCart(item);
	};

	return { add };
}
